module.exports = __webpack_public_path__ + "img/shareLinkWhite.837f0cf8.svg";